import React from 'react';
import './AgeGroup.css';

export default class AgeGroup extends React.Component {
  constructor(props) {
    super(props);
  }

  state = {
    data: 0,
    visibleActions: true,
  };

  componentDidMount() {
    if (this.props.data) this.setState({ data: this.props.data, visibleActions: false });
  }

  increment = () => {
    if (this.state.visibleActions)
      if (this.props.count < this.props.max) {
        this.setState({ data: this.state.data + 1 });
        this.props.increment(this.props.id);
      }
  };

  decrement = () => {
    if (this.state.visibleActions)
      if (this.state.data > 0) {
        this.setState({ data: this.state.data - 1 });
        this.props.decrement(this.props.id);
      }
  };

  render() {
    const { data, visibleActions } = { ...this.state };

    return (
      <div className="row">
        <div className="col s7 m7 l7 right-align">
          <b>{this.props.description}</b>
        </div>
        <div className="row">
          <div className="col s4 m4 l4">
            <div className="counter">
              {visibleActions && (
                <button onClick={() => this.decrement()} className="waves-effect waves-dark actionButton">
                  <b>-</b>
                </button>
              )}
              <span id="counting">{data}</span>
              {visibleActions && (
                <button onClick={() => this.increment()} className="waves-effect waves-dark actionButton">
                  <b>+</b>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
